import { Modal } from 'antd';
import MgUserJobAuthorizationList from 'pages/Configuration/MgUserJobAuthorization/MgUserJobAuthorizationList';
import React from 'react';

export type MgUserJobAuthorizationModalProps = {
  visible: boolean;
  onCancel: () => void;
  attcode: string;
  offerId: number;
  priid?: number;
  mgid: number;
  rvid?: number;
};

const MgUserJobAuthorizationModal = ({
  onCancel,
  visible,
  attcode,
  offerId,
  mgid,
  priid,
  rvid,
}: MgUserJobAuthorizationModalProps) => {
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      width={1600}
      destroyOnClose
      onOk={onCancel}
      footer={null}
    >
      <MgUserJobAuthorizationList
        attcode={attcode}
        offerId={offerId}
        hideFiltersAndBtn
        isModal
        mgid={mgid}
        priid={priid}
        rvid={rvid}
      />
    </Modal>
  );
};

export default MgUserJobAuthorizationModal;
